import axios from 'axios';

import { aadConfig, getAccessToken } from '../aad';
import type { BOE, BOEContent } from '../dto/basisOfEstimate';

export const getBOE = async (projectId: string, phaseId: string, createDefault: boolean = false): Promise<BOE> => {
  await getAccessToken(aadConfig().accountScopes);
  const { data } = await axios.get(
    `${process.env.BOE_HOST}/v1/projects/${projectId}/phases/${phaseId}/boe${createDefault ? `?notFound=create` : ''}`,
  );
  return data;
};

export const createBOE = async (boe: BOE): Promise<BOE> => {
  await getAccessToken(aadConfig().accountScopes);
  const { data } = await axios.post(
    `${process.env.BOE_HOST}/v1/projects/${boe.projectId}/phases/${boe.phaseId}/boe`,
    boe,
  );
  return data;
};

export const updateBOE = async (boe: BOE): Promise<BOE> => {
  await getAccessToken(aadConfig().accountScopes);
  const { data } = await axios.put(
    `${process.env.BOE_HOST}/v1/projects/${boe.projectId}/phases/${boe.phaseId}/boe`,
    boe,
  );
  return data;
};

export const deleteBOE = async (boe: BOE): Promise<void> => {
  await getAccessToken(aadConfig().accountScopes);
  await axios.delete(`${process.env.BOE_HOST}/v1/projects/${boe.projectId}/phases/${boe.phaseId}/boe`);
};

export const getBOEContent = async (
  projectId: string,
  phaseId: string,
  page: string,
  payload?: unknown,
): Promise<BOEContent> => {
  await getAccessToken(aadConfig().accountScopes);
  const { data } = await axios.post(
    `${process.env.BOE_HOST}/v1/projects/${projectId}/phases/${phaseId}/boe/content/${page}`,
    payload,
  );
  return data;
};

export type BOEPdfPayload = {
  isPreview?: boolean;
};

export const boePdf = async (projectId: string, phaseId: string, payload?: BOEPdfPayload): Promise<Uint8Array> => {
  await getAccessToken(aadConfig().accountScopes);
  const { data } = await axios.post(
    `${process.env.BOE_HOST}/v1/projects/${projectId}/phases/${phaseId}/boe-pdf`,
    payload ?? {},
    { responseType: 'arraybuffer' },
  );
  return new Uint8Array(data);
};

export const deleteBOEPdf = async (projectId: string, phaseId: string): Promise<void> => {
  await getAccessToken(aadConfig().accountScopes);
  await axios.delete(`${process.env.BOE_HOST}/v1/projects/${projectId}/phases/${phaseId}/boe-pdf`);
};
